import React from "react";
export const OverflowContainer: React.FC = (props) => <div className="mobileOverflowContainer">{props.children}</div>;
